<mat-card-content house class="w-[300px]">
  <div class="flex justify-between gap-6">
    <section>
      <mat-card-subtitle>
        <time [attr.datetime]="sale.created_at">{{ sale._age }}</time><ng-container *ngIf="salePosterDisplayName">, by
        <a class="underline" [routerLink]="['/p', sale.CorpMember?.slug_id ?? sale.CorpMember?.created_at]">{{ salePosterDisplayName }}</a>
        </ng-container>
    </mat-card-subtitle>
      <!-- todo: should location be clickable? -->
      <mat-card-subtitle>{{sale.CorpMember?._location}}</mat-card-subtitle>
      <mat-card-title>{{ sale.item_name }}</mat-card-title>
    </section>
    <section>&#8358; {{ sale._price }}</section>
  </div>
  <div>
    <section class="two-line-description">
      <p>{{ sale.text }}</p>

      <p *ngIf="sale.minimum_price" >Possible Negotiation: &#8358;<span>{{sale.minimum_price}}</span> </p>
    </section>
  </div>
  <div>
    <section class="post-buttons">
      <ng-container *ngIf="showDeleteOption">
        <button
          type="button"
          (click)="deletePost()"
          mat-icon-button
          color="warn"
          aria-label="Delete this post"
        >
          <mat-icon fontIcon="delete"></mat-icon>
        </button>

        <div class="flex-auto"></div>
      </ng-container>

      <button
        *ngIf="callerService.isLoggedIn"
        type="button"
        [@iconChangeAnimation]="toggleLikeIcon"
        (click)="favoritePost()"
        mat-icon-button
        color="primary"
        aria-label="Like this post"
      >
        <mat-icon [fontIcon]="toggleLikeIcon"></mat-icon>
      </button>
      <button
        *ngIf="callerService.isLoggedIn"
        type="button"
        [@iconChangeAnimation]="toggleBookmarkIcon"
        (click)="bookmarkPost()"
        mat-icon-button
        color="primary"
        aria-label="Save this post"
      >
        <mat-icon [fontIcon]="toggleBookmarkIcon"></mat-icon>
      </button>

      <button
        type="button"
        mat-raised-button
        [matMenuTriggerFor]="chatMenuSmall"
        *ngIf="showMoreOption"
      >
        <!-- @todo: remove ngIf when more than one option is ready -->
        More
      </button>
      <mat-menu #chatMenuSmall="matMenu" yPosition="above">
        <!-- TODO: show this when we're ready for this feature. -->
        <!-- <button type="button" mat-menu-item (click)="copyAgentPhoneNumber()">
              <mat-icon>phone</mat-icon>
              <span>Copy phone number</span>
          </button> -->

        <button
          type="button"
          (click)="chatWithSalePoster()"
          mat-menu-item
        >
          <mat-icon>chat</mat-icon>
          <span>Chat {{ callerService.isLoggedIn ? salePosterChatName : '' }}</span>
          <ng-container *ngIf="!callerService.isLoggedIn">
            <div class="text-xs text-gray-500">Login to chat</div>
          </ng-container>
        </button>

        <!-- TODO: uncomment this when we're ready for this feature. -->
        <!-- <button type="button" mat-menu-item (click)="seeHouseDetails()">
                    <mat-icon>info</mat-icon>
                    <span>View details</span>
                </button> -->
      </mat-menu>
    </section>
  </div>
</mat-card-content>
